import { styled, Box } from '@mui/material';

export const StyledTabsContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    flex: 1,
  },
  paddingTop: `0 !important`,
}));
